import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductModalSupplierFragmentDoc } from './ProductModalSupplier.generated'
import * as Types from './purchasePlus_graphql'

export const ProductItemSupplierFragmentDoc = gql`
  fragment ProductItemSupplier on Supplier {
    id
    ...ProductModalSupplier
  }
  ${ProductModalSupplierFragmentDoc}
` as unknown as DocumentNode<Types.ProductItemSupplierFragment, unknown>
